import React from "react";

import VStack from "../../ui_atoms/VStack";
import MissionWorker from "../../components/editors/MissionWorker";
import { Mission } from "../../__generated__/graphql";
import { useTheme } from "../../hooks/use-theme";
import { MockedProvider } from "@apollo/client/testing/react";
import { ScrollView } from "react-native";
import type { Meta, StoryObj } from "@storybook/react";
import { buildInvitation, buildMission, buildWorkerInfo } from "../factories";
import { GET_CLIENT_WORKERS_AND_INVITATION_WORKERS } from "../../graphql/client";

// generate a list of names
const names = ["Bertrand Culé", "Bernard Tapie", "Jean-Michel Aulas", "Jean-François Copé"];

const workers = names.map((name, i) => {
    return buildWorkerInfo({
        id: `00000000-0007-0000-0000-0000000000${i}`,
        name,
    });
});

const mocks = [
    {
        request: {
            query: GET_CLIENT_WORKERS_AND_INVITATION_WORKERS,
            variables: () => true,
        },
        result: () => ({
            data: {
                getClientWorkers: workers,
                workerInvitationsSent: [buildInvitation()],
            },
        }),
    },
];

function StoryComponent() {
    const { colors } = useTheme();
    const [mission, setMission] = React.useState<Mission>(() => buildMission());
    return (
        <MockedProvider mocks={mocks}>
            <VStack
                gap={0.5}
                style={{
                    padding: 10,
                    flex: 1,
                    justifyContent: "flex-start",
                    alignSelf: "stretch",
                    alignItems: "stretch",
                    backgroundColor: colors.surfaceVariant,
                }}
            >
                <MissionWorker
                    mission={mission}
                    setWorkerInfo={(workerInfo) => {
                        setMission((oldState) => {
                            return { ...oldState, workerInfo };
                        });
                    }}
                />
            </VStack>
        </MockedProvider>
    );
}

const meta = {
    title: "Views/Mission worker",
    component: StoryComponent,
    argTypes: {},
    decorators: [
        (StoryFn) => (
            <ScrollView>
                <StoryFn />
            </ScrollView>
        ),
    ],
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Basic: Story = {
    args: {},
};
